var _g, _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGif(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5713_31776)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C2.44772 0 2 0.447716 2 1V23C2 23.5523 2.44772 24 3 24H21C21.5523 24 22 23.5523 22 23V4L18 0H3Z",
    fill: "#E9F0FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V4H22L18 0Z",
    fill: "#C2CDDE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 22,
    height: 10,
    rx: 1,
    fill: "#F17048"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0107 14.0398C9.96331 13.8864 9.89796 13.7491 9.81463 13.6278C9.73319 13.5047 9.63471 13.3996 9.51918 13.3125C9.40554 13.2254 9.27486 13.16 9.12713 13.1165C8.9794 13.071 8.81842 13.0483 8.64418 13.0483C8.33168 13.0483 8.05327 13.1269 7.80895 13.2841C7.56463 13.4413 7.3724 13.6723 7.23224 13.9773C7.09399 14.2803 7.02486 14.6496 7.02486 15.0852C7.02486 15.5246 7.09399 15.8968 7.23224 16.2017C7.3705 16.5066 7.56274 16.7386 7.80895 16.8977C8.05516 17.0549 8.34115 17.1335 8.6669 17.1335C8.96236 17.1335 9.21804 17.0767 9.43395 16.9631C9.65175 16.8494 9.81937 16.6884 9.93679 16.4801C10.0542 16.2699 10.1129 16.0237 10.1129 15.7415L10.3516 15.7784H8.77202V14.9545H11.1328V15.6534C11.1328 16.1515 11.0268 16.5824 10.8146 16.946C10.6025 17.3097 10.3108 17.59 9.93963 17.7869C9.56842 17.982 9.14228 18.0795 8.66122 18.0795C8.12524 18.0795 7.65459 17.9593 7.24929 17.7188C6.84588 17.4763 6.53054 17.1326 6.30327 16.6875C6.07789 16.2405 5.9652 15.7102 5.9652 15.0966C5.9652 14.6269 6.03149 14.2074 6.16406 13.8381C6.29853 13.4688 6.48603 13.1553 6.72656 12.8977C6.96709 12.6383 7.24929 12.4413 7.57315 12.3068C7.89702 12.1705 8.24929 12.1023 8.62997 12.1023C8.95194 12.1023 9.25213 12.1496 9.53054 12.2443C9.80895 12.3371 10.0561 12.4697 10.272 12.642C10.4898 12.8144 10.6688 13.0189 10.8089 13.2557C10.9491 13.4924 11.041 13.7538 11.0845 14.0398H10.0107ZM13.206 12.1818V18H12.152V12.1818H13.206ZM14.3473 18V12.1818H18.0746V13.0653H15.4013V14.6449H17.8189V15.5284H15.4013V18H14.3473Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5713_31776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "static/media/GIF.f0b397f6009e03a1a7b49d1a701c452e.svg";
export { ForwardRef as ReactComponent };